module.exports = __webpack_public_path__ + "static/media/flower_large.72ff6641.jpg";